import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '@/lib/cn';
import { type Variant, variantClass } from '@/styles/colors/variants';

type Props = HTMLAttributes<HTMLDivElement> & {
  icon?: ReactNode;
  variant?: Variant;
};

const Callout = (props: Props) => {
  const {
    children,
    icon,
    style,
    className,
    variant = 'default',
    ...rest
  } = props;
  return (
    <div
      style={style}
      className={cn(
        'flex border gap-3 items-center px-4 py-3 rounded-md w-full',
        variantClass[variant],
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Callout;
